import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import RequirementDetailSection from "../sections/RequirementDetailSection";
import { REQUIREMENTS_BASE_PATH } from "../helpers/requirementModuleNavigation";

interface RouteProps {
  requirementId: string;
}

const RequirementDetail = () => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");

  // router
  const { requirementId } = useParams<RouteProps>();

  return (
    <>
      <Header
        title={t("requirementDetail.title")}
        includeBreadcrumbs
        links={[{ text: t("requirements.title"), to: REQUIREMENTS_BASE_PATH }]}
      />
      <ModuleContent>
        <RequirementDetailSection requirementId={requirementId} />
      </ModuleContent>
    </>
  );
};

export default RequirementDetail;
